const applicationsModel = vm => ({
  title: vm.$gettext('Company Applications'),
  endpoint: 'applications',
  allowNew: true,
  allowDelete: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'key',
      label: vm.$gettext('Key'),
      sortable: false,
      editable: false
    },
    {
      key: 'company_id',
      label: vm.$gettext('Company ID'),
      sortable: true,
      editable: true,
      required: true,
      formatter: (value, key, item) => {
        return value
      }
    },
    {
      key: 'platform_id',
      label: vm.$gettext('Platform ID'),
      sortable: true,
      editable: true
    },
    {
      key: 'active',
      label: vm.$gettext('Active'),
      sortable: false,
      editable: true,
      required: true,
      description: vm.$gettext('1 or 0')
    },
    {
      key: 'webhook_enabled',
      label: vm.$gettext('Webhook Enabled'),
      sortable: false,
      editable: true,
      required: true,
      description: vm.$gettext('1 or 0')
    },
    {
      key: 'webhook_method',
      label: vm.$gettext('Webhook Method'),
      sortable: false,
      editable: true,
      description: vm.$gettext('POST or GET')
    },
    {
      key: 'webhook_url',
      label: vm.$gettext('Webhook URL'),
      sortable: true,
      editable: true,
      description: vm.$gettext('Complete and valid URL')
    },
    {
      key: 'webhook_headers',
      label: vm.$gettext('Webhook Headers'),
      sortable: false,
      editable: true,
      type: 'JSON',
      description: vm.$gettext('Array of objects (one Key/Value pair per object)')
    }
  ],
  filters: ['id', 'name', 'key', 'company_id'],
  exclude: ['webhook_headers']
})

export default applicationsModel
